import {
  listMngmGroupMappings,
  listMngmGroups,
} from 'account/components/ssoManagement/groups/new-actions'
import {
  listCapabilities,
  listMngmRoles,
} from 'account/components/userManagement/roles/new-actions'
import {
  listAllDomainTenants,
  listTenantRoleAssignments,
  listTenants,
  listUserTenants,
} from 'account/components/userManagement/tenants/new-actions'
import {
  listCredentials,
  listFederatedDomainUsers,
  listUserRoleAssignments,
  listUsers,
} from 'account/components/userManagement/users/new-actions'
import { listRegions } from 'app/plugins/infrastructure/components/regions/actions'
import { listResMgrHosts } from 'app/plugins/infrastructure/components/resMgrHosts/actions'
import { listPools } from 'app/plugins/openstack/components/networks/dns/pools/actions'
import { listRecords } from 'app/plugins/openstack/components/networks/dns/records/actions'
import { listZones } from 'app/plugins/openstack/components/networks/dns/zones/actions'
import { listFloatingIps } from 'app/plugins/openstack/components/networks/floating-ips/actions'
import ListAction from 'core/actions/ListAction'
import {
  listApiGroups,
  listApiResources,
  listCoreApiResources,
} from 'k8s/components/access-control/api-groups/new-actions'
import { listClusterRoleBindings } from 'k8s/components/access-control/cluster-role-bindings/actions'
import { listClusterRoles } from 'k8s/components/access-control/cluster-roles/actions'
import { listRoleBindings } from 'k8s/components/access-control/role-bindings/actions'
import { listRoles } from 'k8s/components/access-control/roles/actions'
import { listApps, listAppsAvailableToCluster } from 'k8s/components/app-catalog/apps/new-actions'
import { listDeployedApps } from 'k8s/components/app-catalog/deployed-apps/new-actions'
import {
  listRepositories,
  listRepositoriesForCluster,
} from 'k8s/components/app-catalog/repositories/new-actions'
import { listKaapiBYOClusters } from 'k8s/components/kaapi/byo-clusters/actions'
import { listKaapiBYOMachineTemplates } from 'k8s/components/kaapi/byo-machine-template/actions'
import { listKaapiClusterUpgradeJobs } from 'k8s/components/kaapi/cluster-upgrade/actions'
import { listKaapiClusters } from 'k8s/components/kaapi/clusters/actions'
import { listKaapiConfigMaps } from 'k8s/components/kaapi/config-maps/actions'
import { listKaapiEvents } from 'k8s/components/kaapi/events/actions'
import { listKaapiHostedControlPlanes } from 'k8s/components/kaapi/hosted-control-plane/actions'
import { listKaapiK8sInstallerConfigTemplates } from 'k8s/components/kaapi/k8s-installer-config-templates/actions'
import { listkaapiKubeadmConfigTemplates } from 'k8s/components/kaapi/kubeadm-config-templates/actions'
import { listKaapiKubeadmControlPlanes } from 'k8s/components/kaapi/kubeadm-control-plane/actions'
import { listKaapiMachineDeployments } from 'k8s/components/kaapi/machine-deployment/actions'
import { listKaapiMachines } from 'k8s/components/kaapi/machines/actions'
import { listkaapiOpenstackMachineTemplates } from 'k8s/components/kaapi/openstack-machine-templates/actions'
import { listKaapiOpenStackServers } from 'k8s/components/kaapi/openstack-servers/actions'
import {
  listKaapiMetricsNodes,
  listKaapiMetricsNodesForAllClusters,
  listKaapiNodes,
  listKaapiNodesForAllClusters,
} from 'k8s/components/kaapi/workload-clusters/nodes/actions'
import { listByoHosts, listByoMachines } from 'k8s/components/nodes/byoh/actions'
import { listConfigMaps } from 'k8s/components/resources/config-maps/actions'
import { listCSIDrivers } from 'k8s/components/resources/csi-drivers/new-actions'
import {
  listCustomResourceDefinitions,
  listCustomResources,
} from 'k8s/components/resources/custom-resource-definitions/actions'
import { listNamespaces } from 'k8s/components/resources/namespaces/actions'
import { listPersistentVolumes } from 'k8s/components/resources/persistent-volume/actions'
import { listPersistentVolumeClaims } from 'k8s/components/resources/persistent-volume-claims/new-actions'
import { listSecrets } from 'k8s/components/resources/secrets/actions'
import {
  listClusterEvents,
  listStorageClasses,
} from 'k8s/components/resources/storage-classes/new-actions'
import { IDataKeys } from 'k8s/datakeys.model'
import { listFlavors } from 'openstack/components/flavors/actions'
import { listImages } from 'openstack/components/images/actions'
import {
  listAllocationCandidates,
  listBlueprints,
  listHostAggregates,
  listHostNetworkConfigs,
  listHypervisors,
  listOverrideCatalog,
} from 'openstack/components/infrastructure/actions'
import { listAvailabilityZones } from 'openstack/components/infrastructure/availability-zones/actions'
import {
  listAllAvailablePorts,
  listLoadBalancers,
  listNetworkAvailability,
  listNetworkRBACPolicies,
  listOctaviaFlavors,
  listOctaviaHealthMonitors,
  listOctaviaListener,
  listOctaviaPoolMembers,
  listOctaviaPools,
  listNetworks as listOpenstackNetworks,
  listPorts as listOpenstackPorts,
  listSubnets as listOpenstackSubnets,
} from 'openstack/components/networks/actions'
import { listRouters as listOpenstackRouters } from 'openstack/components/networks/routers/actions'
import { listSecurityGroups } from 'openstack/components/networks/security-groups/actions'
import { listStacks } from 'openstack/components/orchestration/actions'
import { listSshKeys } from 'openstack/components/security/keys/actions'
import {
  getCinderSingleMessage,
  listCinderMessages,
  listCinderMessagesForVolume,
} from 'openstack/components/storage/messages/actions'
import { listVolumeSnapshots as listOpenstackVolumeSnapshots } from 'openstack/components/storage/snapshots/actions'
import {
  listAllVolumes,
  listAllVolumeTransfers,
  listAvailableVolumes,
  listNonPaginatedVolumes,
  listVolumes as listOpenstackVolumes,
  listSimpleVolumes,
  listSingleVolume,
  listVolumeAttachments,
  listVolumesForImages,
  listVolumeTransfers,
} from 'openstack/components/storage/volumes/actions'
import {
  listAllVirtualMachines as listAllOpenstackVirtualMachines,
  listAllStatewiseVirtualMachinesLite,
  listAllVirtualMachinesLite,
  listVirtualMachines as listOpenstackVirtualMachines,
  listSelfStatewiseVirtualMachinesLite,
  listSelfVirtualMachines,
  listSelfVirtualMachinesLite,
  listSingleVirtualMachine,
  listStatewiseVirtualMachinesLite,
  listVirtualMachinesLite,
} from 'openstack/components/vms/actions'
import { listLeasePolicies, listLeases } from 'openstack/components/vms/leases/actions'
import { listMigrations } from 'openstack/components/vms/migrations/actions'
import {
  listAllServerGroups,
  listServerGroups,
} from 'openstack/components/vms/server-groups/actions'
import { listSsoAttributes } from './plugins/account/components/ssoManagement/attributes/actions'
import { listDomains } from './plugins/account/components/userManagement/domains/actions'
import {
  listBrokenMetadataNetworks,
  listComputeServiceDetails,
  listImageServiceDetails,
  listMetadataServiceHealth,
  listNetworkServiceDetails,
  listStorageServiceDetails,
} from './plugins/infrastructure/components/common/service-health/action'
import { listRegionsMetadata } from './plugins/opencloud/components/regions-metadata/actions'
import {
  listClusterHostGroups,
  listClusterHostGroupsAllTenants,
  listClusterVMHAStatus,
} from './plugins/openstack/components/infrastructure/clusters/actions'
import {
  listApplicationDetails,
  listApplications,
  listBranches,
  listTemplates,
  listTerraformModules,
} from './plugins/openstack/components/orchestration/repositories/actions'
import { listApplicationCredentials } from './plugins/openstack/components/security/application-credentials/actions'
import { listStoragePools } from './plugins/openstack/components/storage/pools/actions'
import {
  listAllTenantDefaultVolumeType,
  listTenantDefaultVolumeType,
  listVolumeTypes,
} from './plugins/openstack/components/storage/volume-types/actions'

const listActionsByKey: Record<keyof IDataKeys, ListAction<keyof IDataKeys> | null> = {
  Apps: listApps,
  AllTenantDefaultVolumeTypes: listAllTenantDefaultVolumeType,
  AppsAvailableToCluster: listAppsAvailableToCluster,
  ApiEndpoints: null, // @todo
  ApiGroups: listApiGroups,
  ApiResources: listApiResources,
  CoreApiResources: listCoreApiResources,
  AppDetails: null, // @todo
  AppVersions: null,
  Repositories: listRepositories,
  DeployedApps: listDeployedApps,
  RepositoriesForCluster: listRepositoriesForCluster,
  CloudProviderDetails: null, // @todo
  CloudProviderRegionDetails: null, // @todo
  ClusterRoleBindings: listClusterRoleBindings,
  ClusterRoles: listClusterRoles,
  Endpoints: null,
  PrometheusInstances: null, // @todo
  PrometheusServiceMonitors: null, // @todo
  PrometheusAlertManagers: null, // @todo
  StorageClasses: listStorageClasses,
  CSIDrivers: listCSIDrivers,
  PersistentVolumes: listPersistentVolumes,
  PersistentVolumeClaims: listPersistentVolumeClaims,
  Ssh: null, // @todo
  ServiceCatalog: null, // @todo
  DeployedAppDetails: null, // @todo
  Flavors: listFlavors, // @todo
  KubeRoles: listRoles,
  KubeServiceDetails: null, // @todo
  ManagementCredentials: listCredentials,
  ManagementGroups: listMngmGroups,
  ManagementGroupsMappings: listMngmGroupMappings,
  ManagementRoles: listMngmRoles,
  ManagementTenants: listTenants,
  AllTenants: listAllDomainTenants,
  ManagementTenantsRoleAssignments: listTenantRoleAssignments,
  ManagementUsers: listUsers,
  FederatedDomainUsers: listFederatedDomainUsers,
  ManagementUsersRoleAssignments: listUserRoleAssignments,
  Namespaces: listNamespaces,
  Tenants: listTenants,
  PodTemplates: null,
  Regions: listRegions,
  ResMgrHosts: listResMgrHosts,
  RoleBindings: listRoleBindings,
  UserTenants: listUserTenants,
  Domains: listDomains,
  ConfigMaps: listConfigMaps,
  Users: listUsers,
  VirtualMachineDetails: null, // @todo
  Events: listClusterEvents,
  Secrets: listSecrets,
  Images: listImages,
  Blueprints: listBlueprints,
  OverrideCatalog: listOverrideCatalog,
  HostRoleOverrides: null, // requires { hostId, role } params — no canonical all-hosts refresh
  ImageMembers: null,
  OpenstackVirtualMachines: listOpenstackVirtualMachines,
  AllOpenstackVirtualMachines: listAllOpenstackVirtualMachines,
  SingleOpenstackVirtualMachine: listSingleVirtualMachine,
  SelfOpenstackVirtualMachines: listSelfVirtualMachines,
  //Lite VM calls
  OpenstackVirtualMachinesLite: listVirtualMachinesLite,
  AllOpenstackVirtualMachinesLite: listAllVirtualMachinesLite,
  SelfOpenstackVirtualMachinesLite: listSelfVirtualMachinesLite,
  OpenstackStatewiseVirtualMachinesLite: listStatewiseVirtualMachinesLite,
  AllOpenstackStatewiseVirtualMachinesLite: listAllStatewiseVirtualMachinesLite,
  SelfOpenstackStatewiseVirtualMachinesLite: listSelfStatewiseVirtualMachinesLite,

  OpenstackNetworks: listOpenstackNetworks,
  OpenstackSubnets: listOpenstackSubnets,
  OpenstackPorts: listOpenstackPorts,
  OpenstackAllAvailablePorts: listAllAvailablePorts,
  OpenstackRouters: listOpenstackRouters,
  OpenstackVolumes: listOpenstackVolumes,
  SingleOpenstackVolume: listSingleVolume,
  AllOpenstackVolumes: listAllVolumes,
  OpenstackVolumesLite: listSimpleVolumes,
  NonPaginatedOpenstackVolumes: listNonPaginatedVolumes,
  OpenstackVolumesForImages: listVolumesForImages,
  AvailableOpenstackVolumes: listAvailableVolumes,
  VolumeTransfers: listVolumeTransfers,
  AllVolumeTransfers: listAllVolumeTransfers,
  OpenstackVolumeSnapshots: listOpenstackVolumeSnapshots,
  CinderMessages: listCinderMessages,
  CinderMessagesForVolume: listCinderMessagesForVolume,
  CinderMessage: getCinderSingleMessage,
  VolumeAttachments: listVolumeAttachments,
  NetworkIpAvailability: listNetworkAvailability,
  NetworkRBACPolicies: listNetworkRBACPolicies,
  // TODO(PCD-8479): should be `listResmgrHosts` (cacheKey ResmgrHosts). The legacy action's cacheKey is
  // ResMgrHosts, so isListAction() skips it and `.addDependency(DataKeys.ResmgrHosts)` never refetches
  // hosts (listClusterHostGroups, listHostAggregates).
  ResmgrHosts: listResMgrHosts,
  Hypervisors: listHypervisors,
  AllocationCandidates: listAllocationCandidates,
  SshKeys: listSshKeys,
  FloatingIps: listFloatingIps,
  SecurityGroups: listSecurityGroups,
  VolumeTypes: listVolumeTypes,
  HostAggregates: listHostAggregates,
  Stacks: listStacks,
  TenantDefaultVolumeTypes: listTenantDefaultVolumeType,
  AvailabilityZones: listAvailabilityZones,
  ComputeServiceDetails: listComputeServiceDetails,
  StorageServiceDetails: listStorageServiceDetails,
  NetworkServiceDetails: listNetworkServiceDetails,
  MetadataServiceHealth: listMetadataServiceHealth,
  BrokenMetadataNetworks: listBrokenMetadataNetworks,
  ImageServiceDetails: listImageServiceDetails,
  ServerGroups: listServerGroups,
  AllServerGroups: listAllServerGroups,
  StoragePools: listStoragePools,
  HostNetworkConfigs: listHostNetworkConfigs,
  DnsPools: listPools,
  DnsZones: listZones,
  DnsRecords: listRecords,
  LoadBalancers: listLoadBalancers,
  Templates: listTemplates,
  TerraformModule: listTerraformModules,
  RepositoryBranches: listBranches,
  Applications: listApplications,
  ApplicationDetails: listApplicationDetails,
  Repository: listRepositories,
  OctaviaFlavors: listOctaviaFlavors,
  OctaviaListeners: listOctaviaListener,
  OctaviaPools: listOctaviaPools,
  OctaviaPoolMembers: listOctaviaPoolMembers,
  OctaviaHealthMonitors: listOctaviaHealthMonitors,
  ClusterHostGroups: listClusterHostGroups,
  ClusterHostGroupsAllTenants: listClusterHostGroupsAllTenants,
  ClusterVMHAStatus: listClusterVMHAStatus,
  DatabaseClusters: null,
  LeasePolicies: listLeasePolicies,
  Leases: listLeases,
  SsoAttributes: listSsoAttributes,
  VmMigrations: listMigrations,

  // Todo: create list actions for these
  KaapiClusters: listKaapiClusters,
  KaapiHostedControlPlanes: listKaapiHostedControlPlanes,
  KaapiOpenStackMachineTemplates: listkaapiOpenstackMachineTemplates,
  KaapiOpenStackServers: listKaapiOpenStackServers,
  KaapiEvents: listKaapiEvents,
  KaapiKubeadmConfigTemplates: listkaapiKubeadmConfigTemplates,
  KaapiMachineDeployments: listKaapiMachineDeployments,
  KaapiMachines: listKaapiMachines,
  KaapiClusterAddons: null,
  KaapiTenants: null,
  KaapiClusterUpgradeJobs: listKaapiClusterUpgradeJobs,
  KaapiConfigMaps: listKaapiConfigMaps,
  KaapiNodes: listKaapiNodes,
  KaapiNodesAllClusters: listKaapiNodesForAllClusters,
  KaapiMetricsNodes: listKaapiMetricsNodes,
  KaapiMetricsNodesAllClusters: listKaapiMetricsNodesForAllClusters,
  CustomResourceDefinitions: listCustomResourceDefinitions,
  CustomResources: listCustomResources,
  KaapiBYOHosts: listByoHosts,
  KaapiBYOMachines: listByoMachines,
  KaapiBYOClusters: listKaapiBYOClusters,
  KaapiBYOMachineTemplates: listKaapiBYOMachineTemplates,
  KaapiK8sInstallerConfigTemplates: listKaapiK8sInstallerConfigTemplates,
  ControlPlaneServicesHealth: null,
  KaapiKubeadmControlPlanes: listKaapiKubeadmControlPlanes,

  // OpenCloud
  RegionsMetadata: listRegionsMetadata,
  ApplicationCredentials: listApplicationCredentials,

  Capabilities: listCapabilities,
  // TODO - Remove these
  CloudProviders: null,
  ImportedClusters: null,
  KubeServices: null,
  Nodes: null,
  PrometheusRules: null,
  ServiceAccounts: null,
  Services: null,
  Silences: null,
  SupportedRoleVersions: null,
}

export default listActionsByKey
